var map = {
	"./add-icon.svg": "615f",
	"./arrow-left.svg": "9ba7",
	"./basket.svg": "cb22",
	"./checked-circle.svg": "0c39",
	"./close.svg": "6282",
	"./collapse-arrow.svg": "c85c",
	"./loader-white.svg": "3f5f",
	"./loader.svg": "e063",
	"./mastercard.svg": "7110",
	"./paypal.svg": "314a",
	"./popular.svg": "e3f4",
	"./remove-icon.svg": "a540",
	"./search.svg": "0930",
	"./unchecked-circle.svg": "59f9",
	"./veg.svg": "d8e3",
	"./vegan.svg": "0195",
	"./visa.svg": "81b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";